import { CNC } from '@constants';

export const isCNC = (id: number) => CNC.includes(id);
